<template>
  <div>
    <a-breadcrumb separator="/">
      <a-breadcrumb-item :to="{ path: '/admin/datasources' }">Datasources</a-breadcrumb-item>
      <a-breadcrumb-item>New</a-breadcrumb-item>
    </a-breadcrumb>
    <a-row type="flex" class="area-header">
      <h1 v-if="!isEditMode">New Datasource</h1>
      <h1 v-else>Edit Datasource</h1>
    </a-row>

    <a-form ref="form" :model="datasource" label-width="120px" label-position="right">
      <a-form-item label="Datasource name">
        <a-input v-model="datasource.name"></a-input>
      </a-form-item>
      <a-form-item label="Title Field">
        <a-select v-model="datasource.titleField" filterable placeholder="Select">
          <a-select-option
            v-for="field in datasource.fields"
            :key="`field-${field.id}`"
            :value="field.id"
          >{{ field.label }}</a-select-option>
        </a-select>
      </a-form-item>
    </a-form>

    <h2>Fields</h2>
    <app-properties-editor
      v-if="loadCompleted"
      :properties="datasource.fields"
      config-type="datasource"
      @apply="updateProperties('datasource', $event)"
    ></app-properties-editor>

    <a-button
      :loading="isLoading"
      type="primary"
      @click="save()"
    >{{ isEditMode ? 'Update' : 'Create' }}</a-button>
  </div>
</template>

<script>
import AppPropertiesEditor from "@/components/property/Editor";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loadCompleted: false,
      isLoading: false,
      datasource: {
        name: "",
        fields: [],
        workspace_id: null
      }
    };
  },
  methods: {
    updateProperties(type, eventValue) {
      this.$log.info(type, eventValue);
      this.$set(this.datasource, `${type}BoothProperties`, eventValue);
    },
    save() {
      this.isLoading = true;

      this.$store
        .dispatch(
          `datasource/${this.isEditMode ? "update" : "create"}`,
          this.datasource
        )
        .then(() => {
          this.isLoading = false;
          this.$router.push("/admin/datasources");
        })
        .catch(() => {
          this.$message.error("Oops, something went wrong.");
          this.isLoading = false;
        });
    }
  },
  computed: {
    isEditMode() {
      return this.$route.params.id != "new";
    }
  },
  async created() {
    // this.$store.commit("SET_IS_FETCHING", true);

    if (this.isEditMode) {
      const datasource = await this.$store.dispatch("datasource/fetchSingle", {
        id: this.$route.params.id
      });
      this.$set(this, "datasource", datasource);
    }

    this.loadCompleted = true;

    // this.$store.commit("SET_IS_FETCHING", false);
  },
  components: {
    AppPropertiesEditor
  }
};
</script>

<style lang="scss">

</style>
